import { TranslateService } from './../../shared/translate/translate.service';
import { AuthService } from './../../shared/models/auth.service';
import { IKeyValueInterface } from './../../shared/config';
import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ContractTypeModel } from '../models/contractType.model';
import { ContractTypeService } from '../models/contractType.service';
import { Observable } from 'rxjs/Observable';
import { Router, ActivatedRoute } from '@angular/router';
import { WeGoConfig, IAPIResponse, ApplicationRouteURL, UserRoles, DataListModel } from '../../shared/config';

@Component({
  selector: 'wego-contractType-history',
  template: require('../views/contractType-history.component.html'),
  providers: [ContractTypeService],

})
export class ContractTypeHistoryComponent implements OnInit {
  DataListModel: DataListModel;
  contractTypeList: ContractTypeModel[];
  errorModel: IKeyValueInterface[];
  apiErrorMsg: string;
  isLoading: boolean;
  message: string;
  contractGroupName: string;
  versionId: string;

  @ViewChild('ContractTypeHistoryModal') public ContractTypeHistoryModal: any;

  constructor(private contractTypeService: ContractTypeService
    , private activeRoute: ActivatedRoute
    , private authService: AuthService
    , private router: Router
    , private translate: TranslateService) {
  }

  ngOnInit() {
    this.DataListModel = new DataListModel();
  }
  public OnSort(sortName: string) {
    this.DataListModel.sortType = sortName;
    this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
    this.GetContractTypeHistory();
  }

  public OnSearch(event: any) {
    this.DataListModel.searchTerm = event.searchTerm;
    this.DataListModel.currentPage = 1;
    this.GetContractTypeHistory();
  }

  public OnPageChanged(event: any): void {
    this.DataListModel.currentPage = event.page;
    this.GetContractTypeHistory();
  };

  public OnPagingChange(event: any) {
    this.DataListModel.currentPage = 1;
    this.DataListModel.totalItems = 0;
    this.DataListModel.itemsPerPage = event.itemPerPage;
    this.GetContractTypeHistory();
  }
  public GetContractTypeHistory() {
    console.log('this.versionId');
    console.log(this.versionId);
    this.isLoading = true;
    this.contractTypeService.GetContractTypeHistory(this.versionId, this.DataListModel)
      .subscribe(
      res => {
        this.contractTypeList = res.data;
        this.DataListModel.totalItems = res.totalRecords;
        this.DataListModel.infoMessage = res.error;
        this.isLoading = false;
      },
      error => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      });
  }




  public show(): void {
    this.DataListModel.currentPage = 1;
    this.DataListModel.totalItems = 0;
    this.DataListModel.sortType = "";
    this.DataListModel.sortReverse = null;
    this.DataListModel.searchTerm = "";
    this.DataListModel.infoMessage = "";
    this.GetContractTypeHistory();
    this.ContractTypeHistoryModal.show();
  }

  public hide(): void {
    this.ContractTypeHistoryModal.hide();
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/contractType/components/contractType-history.component.ts